import React from 'react';
import { FIELDS_BUILT_IN } from '../constants.js';
import FileWidget from '../components/FileWidget';
import CsvPreviewWidget from '../components/CsvPreviewWidget';
import UploadedDataWidget from '../components/UploadedDataWidget';
import HeadersWidget from '../components/HeadersWidget';
import ProjectSourceWidget from '../components/ProjectSourceWidget.js';
import FieldAdderWidget from '../components/FieldAdderWidget.js';

const PROJECT_FORM_STEPS = [
  {
    schema: {
      title: 'Project details',
      type: 'object',
      properties: {
        name: { type: 'string', title: 'Name', default: '' }
      },
      required: ['name']
    },
    uiSchema: {}
  }
];
const IMPORT_FORM_STEPS = [
  {
    schema: {
      // title: 'Select a xlsx or a csv file and upload it',
      title: 'Upload file (csv or xlsx)',
      type: 'object',
      properties: {
        file: { type: 'string', title: 'File', default: false },
        delimiter: {
          type: 'string',
          title: 'CSV Delimiter',
          default: 'auto',
          enum: ['auto', ';', ',', '|', 'tab']
        },
        newline: {
          type: 'string',
          title: 'CSV Newline',
          default: 'auto',
          enum: ['auto', '\\r', '\\n', '\\r\\n']
        },
        filesUploaded: {
          type: 'array',
          title: 'Files Uploaded',
          readonly: true,
          items: {
            title: 'File',
            type: 'string'
          }
        },
        filesImported: {
          type: 'array',
          title: 'Files Imported',
          readonly: true,
          items: {
            title: 'File',
            type: 'string'
          }
        },
        headers: {
          type: 'string',
          title: 'Output headers'
        }
      }
    },
    uiSchema: {
      filesImported: {
        'ui:options': {
          orderable: false,
          addable: false,
          removable: false
        }
      },
      filesUploaded: {
        'ui:options': {
          orderable: false,
          addable: false,
          removable: false
        }
      },
      //TODO check if we can use this
      // filesUploadedx: {
      //   'ui:widget': props => (
      //     <div>
      //       <ul>
      //         {props.value &&
      //           props.value.length &&
      //           props.value.map((name, index) => (
      //             <li key={`key${index}`}>{name}</li>
      //           ))}
      //       </ul>
      //     </div>
      //   )
      // },
      file: {
        'ui:widget': FileWidget
      },
      uploadedData: {
        'ui:widget': UploadedDataWidget,
        'ui:readonly': true,
        'ui:options': {
          orderable: false,
          addable: false,
          removable: false
        }
      },
      csvPreview: {
        'ui:widget': CsvPreviewWidget,
        'ui:readonly': true,
        'ui:options': {
          orderable: false,
          addable: false,
          removable: false
        }
      }
    }
  },
  {
    schema: {
      title: 'Import from previous project (optional)',
      description: 'If you want to import fields from a previous project',
      type: 'object',
      required: [],
      properties: {
        projectSource: {
          type: 'integer',
          title: 'Project'
        }
      }
    },
    uiSchema: {
      projectSource: {
        'ui:widget': ProjectSourceWidget
      }
    }
  },
  {
    schema: {
      title: `Agent' Screen Configuration`,
      type: 'object',
      required: [],
      properties: {
        newHeaders: {
          type: 'array',
          title: 'Add custom fields',
          items: {
            type: 'string',
            enum: FIELDS_BUILT_IN
          },
          uniqueItems: true
        },
        // fileHeaders: {
        //   type: 'array',
        //   title: 'File headers',
        //   items: {
        //     type: 'string'
        //   },
        //   uniqueItems: true
        // }
        columnsNumber: {
          title: 'Number of columns',
          type: 'integer',
          default: 3
        },

        sections: {
          type: 'array',
          title: 'Sections',
          items: {
            type: 'object',
            properties: {
              title: { title: 'Section Title', type: 'string', default: '' },
              fieldsNumber: {
                title: 'Fields number',
                type: 'integer'
              }
            }
          }
        }
      }
    },
    uiSchema: {
      newHeaders: {
        'ui:widget': FieldAdderWidget
      },
      fileHeaders: {
        'ui:widget': HeadersWidget
      },
      columnsNumber: {
        'ui:widget': 'updown'
      },
      sections: {
        items: {
          fieldsNumber: {
            'ui:widget': 'updown'
          }
        }
      }
    }
  },
  {
    schema: {
      title: 'Access',
      type: 'object',
      properties: {
        agents: {
          type: 'array',
          title: 'Agents for project',
          uniqueItems: true,
          items: {
            type: 'string',
            enum: [],
            enumNames: []
          }
        },
        customers: {
          type: 'array',
          title: 'Customers for project',
          uniqueItems: true,
          items: {
            type: 'string',
            enum: [],
            enumNames: []
          }
        },
        callDays: {
          type: 'number',
          title: 'Call days (0 for hiding the stats)'
        }
      }
    },
    uiSchema: {
      agents: {
        'ui:widget': 'checkboxes'
      },
      customers: {
        'ui:widget': 'checkboxes'
      }
    }
  }
];

const ALL_FORM_STEPS = [...PROJECT_FORM_STEPS, ...IMPORT_FORM_STEPS];

export const getProjectFormSchemaSteps = projectId => {
  if (!projectId) {
    return PROJECT_FORM_STEPS;
  }
  return ALL_FORM_STEPS;
};

export const STEP_FOR_PREVIEW_FORM = 3;



// WEBPACK FOOTER //
// ./src/helpers/project.js